import { Link, useNavigate, type LinkProps } from 'react-router';

import { forwardRef } from 'react';
import { SoundType } from '../../../audio';
import { useSound } from '../../../hooks';

type SoundLinkProps = LinkProps & {
  sound?: SoundType;
  delay?: number;
};

export const SoundLink = forwardRef<HTMLAnchorElement, SoundLinkProps>(
  ({ sound, delay = 80, onClick, to, ...props }, ref) => {
    const navigate = useNavigate();
    const { play } = useSound();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      // respetar onClick original si existe
      onClick?.(e);

      // si el evento fue prevenido, no hacemos nada
      if (e.defaultPrevented) return;

      if (sound) {
        play(sound);
      }

      // importante: evitar navegación inmediata del Link
      e.preventDefault();

      setTimeout(() => {
        navigate(to as string);
      }, delay);
    };

    return <Link ref={ref} to={to} {...props} onClick={handleClick} />;
  },
);

SoundLink.displayName = 'SoundLink';
